import styled from 'styled-components';
import toColorString from 'polished/lib/color/toColorString';
import color from '@decisiv/design-tokens/lib/color';
import rem from 'polished/lib/helpers/rem';
import spacing from '@decisiv/design-tokens/lib/spacing';
import Flex from '@decisiv/ui-components/lib/components/Flex';

// Same bordered panel as ExecutionDetails' "Additional Information", except
// values here (description, user message) are long enough to need wrapping.
export const InfoPanel = styled(Flex).attrs({
  flexDirection: 'column',
  marginTop: 2,
})`
  border: ${rem(spacing.base * 0.1)} solid ${toColorString(color.base.halfMoon)};
  padding: ${rem(spacing.base)};
`;

export const LineDivider = styled.div`
  width: 100%;
  height: ${rem(spacing.base * 0.1)};
  background: ${toColorString(color.opacity.charcoal15)};
  margin-top: ${rem(spacing.base)};
`;

export const TableWrapper = styled.div`
  width: 100%;

  table {
    width: 100%;
    table-layout: fixed;
  }

  /* TYPE */
  th:nth-child(1),
  td:nth-child(1) {
    width: 12rem;
  }

  /* TITLE */
  th:nth-child(2),
  td:nth-child(2) {
    width: 16rem;
  }

  /* USER MESSAGE — takes the remaining space */
  th:nth-child(3),
  td:nth-child(3) {
    width: auto;
  }

  td:nth-child(3) > span {
    word-break: break-word;
    white-space: normal;
  }

  /* DETAILS */
  th:nth-child(4),
  td:nth-child(4) {
    width: 6rem;
  }
`;

export default TableWrapper;
